import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiTooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  popper: {
    top: 0,
    // These position styles are needed to fix an overflow issue when a button with a tooltip triggers a popover.
    left: 0 // The inline positioning on the popper should override these values.
  },
  tooltip: {
    fontSize: theme.typography.caption.fontSize
  }
}));
export const delayValueMap = {
  instant: 0,
  short: 240,
  long: 960
};
export const Tooltip = props => {
  const {
    className,
    delay = "short",
    PopperProps,
    placement = "top",
    ...otherProps
  } = props;
  const classes = useStyles(props);
  const leaveDelay = delayValueMap[delay];
  const enterDelay = leaveDelay;
  const modifiers = PopperProps?.modifiers;
  const renderedPopperProps = {
    ...PopperProps,
    modifiers: {
      ...modifiers,
      flip: {
        enabled: true,
        ...modifiers?.flip
      },
      preventOverflow: {
        enabled: true,
        boundariesElement: "scrollParent",
        ...modifiers?.preventOverflow
      }
    }
  };
  return /*#__PURE__*/React.createElement(MuiTooltip, _extends({
    leaveDelay: leaveDelay,
    enterDelay: enterDelay,
    placement: placement
  }, otherProps, {
    PopperProps: renderedPopperProps,
    classes: {
      ...classes,
      popper: classNames("prmbl-tooltip", className, classes.popper)
    }
  }));
};
Tooltip.defaultProps = {
  delay: "short",
  placement: "top"
};
export default Tooltip;